import { isTruthy } from '@ardoq/common-helpers';
import { formatOtherLabel, type GraphEdgeBase } from '@ardoq/graph';
import { measureNodeLabel } from '@ardoq/graph-labeling';
import { wrapString } from 'tabview/blocks/misc/string';
import { MODERNIZED_BLOCK_DIAGRAM_EDGE_LABEL_MAX_WIDTH as MAX_WIDTH } from 'yfilesExtensions/styles/consts';
import {
  MODERNIZED_BLOCK_DIAGRAM_LABEL_MAX_LINES as MAX_LINES,
  MODERNIZED_BLOCK_DIAGRAM_OTHER_LABEL_PADDING as PADDING,
} from 'yfilesExtensions/styles/modernized/consts';

/** @returns a map of the edge ids and their wrapped other labels */
const edgeOtherLabels = (edgesSource: GraphEdgeBase[]) =>
  new Map(
    edgesSource
      .map((edge): [string, string[][]] | null => {
        const { id } = edge;
        const itemLabels = edge.getItemLabels();
        if (!itemLabels?.otherLabels?.length) {
          return null;
        }
        const { otherLabels } = itemLabels;
        return [
          id,
          otherLabels.map(otherLabel => {
            const availableWidth = MAX_WIDTH - 2 * PADDING;
            return wrapString(
              formatOtherLabel(otherLabel),
              availableWidth,
              measureNodeLabel,
              MAX_LINES
            );
          }),
        ];
      })
      .filter(isTruthy)
  );

export { edgeOtherLabels };
